'use client'

import { useEffect, useState } from 'react'

export default function DevHelperGrid({}) {
	const [guidesOn, setGuidesOn] = useState(false)

	useEffect(() => {
		function listenForShortcut(event: KeyboardEvent) {
			if (event.code == 'KeyG' && event.altKey) {
				if (guidesOn) {
					setGuidesOn(false)
				} else {
					setGuidesOn(true)
				}
			}
		}
		window.addEventListener('keyup', listenForShortcut, false)
		return () => window.removeEventListener('keyup', listenForShortcut, false)
	}, [guidesOn])

	if (!guidesOn) return null

	return (
		<div className="fixed z-[999999] inset-0 site-grid px-site [&>div]:border-x [&>div]:border-x-[#f00]/35 [&>div]:dark:border-x-[#0ff]/50 pointer-events-none">
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
		</div>
	)
}
